export const FIELD_TYPES = [
  { type: "signature", label: "Signature", defaultW: 200, defaultH: 60, color: "#3b82f6" },
  { type: "initials", label: "Initials", defaultW: 80, defaultH: 40, color: "#8b5cf6" },
  { type: "date", label: "Date", defaultW: 150, defaultH: 30, color: "#f59e0b" },
  { type: "autofill_name", label: "Full Name", defaultW: 180, defaultH: 30, color: "#10b981" },
  { type: "autofill_company", label: "Company", defaultW: 180, defaultH: 30, color: "#06b6d4" },
  { type: "text", label: "Text", defaultW: 200, defaultH: 30, color: "#6366f1" },
];
